import { FaArrowRight } from "react-icons/fa";
import { profile, projects } from "../data";
import SectionHeading from "./SectionHeading";

function Projects() {
  return (
    <section className="section container" id="projects">
      <SectionHeading title="Projects" />

      <div className="work-grid">
        {projects.map((project, index) => (
          <article className={`work-card tone-${project.tone}`} key={project.title}>
            <div className="work-top">
              <span className="mono">({String(index + 1).padStart(2, "0")})</span>
              <span className="mono">{project.tag}</span>
            </div>

            <h3>{project.title}</h3>
            <p className="work-subtitle">{project.subtitle}</p>

            <ul className="work-points">
              {project.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>

            <div className="work-stack">
              {project.stack.map((tech) => (
                <span key={tech}>{tech}</span>
              ))}
            </div>

            <div className="work-links">
              {project.live && (
                <a
                  href={project.live}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="work-live"
                >
                  Live demo <FaArrowRight />
                </a>
              )}
              <a
                href={profile.github}
                target="_blank"
                rel="noopener noreferrer"
                className="work-link"
              >
                View on GitHub <FaArrowRight />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Projects;
